// Client-side persistence + state helpers for the academic-standards UI.

export const STANDARDS_SELECTED_STATE_KEY = "standards_selected_state";
// The server's pseudo-state for Common Core rows; deliberately not a
// two-letter code so it can't be misread as a state abbreviation.
export const COMMON_CORE_STATE = "CCSS";

// All localStorage access below is guarded: some privacy modes throw on any
// storage access, and the right degradation is "not sticky".

export const getStoredStandardsState = (): string | null => {
  try {
    return localStorage.getItem(STANDARDS_SELECTED_STATE_KEY);
  } catch {
    return null;
  }
};

export const setStoredStandardsState = (state: string): void => {
  try {
    localStorage.setItem(STANDARDS_SELECTED_STATE_KEY, state);
  } catch {
    // Not sticky in privacy modes; selection still works within the session.
  }
};

// "US-NJ" -> "NJ"; null when the user has no known state.
export const stateFromSubdivisionCode = (
  subdivisionCode: string | undefined
): string | null => subdivisionCode?.split("-").pop()?.toUpperCase() ?? null;

// Which state pill the standards modal opens on. `available` is the list of
// state abbreviations offered as pills (display order, CCSS first);
// subdivisionCode is the user's ISO 3166-2 code from flags (e.g. "US-NJ").
export const pickInitialStandardsState = (
  available: string[],
  stored: string | null,
  subdivisionCode: string | undefined
): string | null => {
  if (stored && available.includes(stored)) {
    return stored;
  }
  const userState = stateFromSubdivisionCode(subdivisionCode);
  if (userState && available.includes(userState)) {
    return userState;
  }
  if (available.includes(COMMON_CORE_STATE)) {
    return COMMON_CORE_STATE;
  }
  return available.length > 0 ? available[0] : null;
};
